import { useEffect, useState } from 'react'
import { ToggleGroup, ToggleGroupItem } from '@/components/ui/toggle-group'
import { getSavedFontScale, setFontScale } from '@/lib/fontScale'

const FONT_SCALE_OPTIONS = [
  { value: '1', label: 'A' },
  { value: '1.2', label: 'A+' },
  { value: '1.4', label: 'A++' },
] as const

export const FontSizeSwitch = () => {
  const [fontScaleValue, setFontScaleValue] = useState('1.2')

  useEffect(() => {
    setFontScaleValue(String(getSavedFontScale()))
  }, [])

  return (
    <ToggleGroup
      className="rounded-full shadow-2xl px-2 py-1"
      type="single"
      value={fontScaleValue}
      onValueChange={(value) => {
        if (!value) return
        setFontScaleValue(value)
        setFontScale(Number(value))
      }}
      aria-label="Global font size"
    >
      {FONT_SCALE_OPTIONS.map((option) => (
        <ToggleGroupItem key={option.value} value={option.value} aria-label={`Font size ${option.label}`}>
          {option.label}
        </ToggleGroupItem>
      ))}
    </ToggleGroup>
  )
}
